import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {TableFilterKey} from "../../model/filters/TableFiltersDefinitions";

interface ScrollPositionState {
    [key: string]: number;
}

const initialState: ScrollPositionState = {};

interface ScrollPositionData {
    key: TableFilterKey,
    scrollTop: number
}

export const scrollPositionSlice = createSlice({
    name: "scrollPosition",
    initialState,
    reducers: {
        setScrollPosition: (
            state,
            action: PayloadAction<ScrollPositionData>
        ) => {
            const {key, scrollTop} = action.payload;
            state[key] = scrollTop;
        }
    },
});

export const scrollPositionActions = scrollPositionSlice.actions

export const scrollPositionReducer = scrollPositionSlice.reducer;